// engine
import { ORIENTATION } from '@aceroll/core';

// configs
import { controllersConfig } from './controllers-config';

function replaceCanvas() {
    const hacksawView = document.getElementById('webgl');
    hacksawView.style.display = 'none';
    const wrapper = document.getElementById('GameWrapper');
    const canvas = document.createElement('canvas');
    canvas.id = 'game';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    wrapper.appendChild(canvas);
    return canvas;
}

export const appConfig = {
    renderer: {
        width: window.innerWidth,
        height: window.innerHeight,
        powerPreference: 'high-performance',
        resolution: Math.min(window.devicePixelRatio || 1, 2),
        canvas: replaceCanvas()
    },
    stage: {
        label: 'app'
    },
    screen: {
        baseSize: {
            [ORIENTATION.LANDSCAPE]: {
                width: 2340,
                height: 1080
            },
            [ORIENTATION.PORTRAIT]: {
                width: 1080,
                height: 2340
            }
        },
        resizeSelector: '#GameWrapper',
        resizeMethod: 'window'
    },
    gameFlow: {
        controllers: controllersConfig,
    }
}